import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import HeaderPrivado from "../components/HeaderPrivado";
import "../components/SidebarUser.css";
import { API_URL } from "../config";
import { revokeUnacknowledgedServerSession, buildLoginRedirectTarget } from "../utils/browserSessionGuard";
import { isSessionAcknowledged } from "../utils/sessionGate";
import { clearSessionKeys } from "../utils/sessionKeys";

const PrivateLayoutAdmin = () => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;

    const verifyAuth = async () => {
      try {
        if (!isSessionAcknowledged()) {
          await revokeUnacknowledgedServerSession();
          return;
        }

        const response = await fetch(`${API_URL}/verificar-token`, {
          method: "GET",
          credentials: "include",
        });

        if (cancelled) {
          return;
        }

        if (response.ok) {
          setIsAuthenticated(true);
          return;
        }

        clearSessionKeys();
      } catch (error) {
        console.error("Auth check failed:", error);
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    verifyAuth();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) return <div>Cargando...</div>;

  if (!isAuthenticated) {
    const redirectTo = buildLoginRedirectTarget(location.pathname, location.search) || "/login";
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <div className="side-containerPrinci">
      <HeaderPrivado />
      <div className="side-main-layout">
        <main className="side-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default PrivateLayoutAdmin;
